// export const baseUrl = process.env.REACT_APP_BASE_URL

export const baseUrl = window.location.origin.includes('dev')
   ? 'https://dev.imine.ru/api/v1'
   : 'https://imine.ru/api/v1'
export const imageUrl = window.location.origin.includes('dev')
   ? 'https://dev.imine.ru'
   : 'https://imine.ru'